<template>
    <div class="prop-box" :style="propStyle">
      <!-- 道具背景图 -->
      <div class="prop-box-bg">
        <img v-if="prop_type === 0"
            :src="require('@/assets/images/YuliApp/weeklyTask/bg_reward_item_black.svg')">
        <img v-if="prop_type === 1"
            :src="require('@/assets/images/YuliApp/weeklyTask/bg_reward_item_white.svg')">
        <img v-if="prop_type === 2"
            :src="require('@/assets/images/YuliApp/weeklyTask/bg_reward_item_green.svg')">
        <img v-if="prop_type === 3"
            :src="require('@/assets/images/YuliApp/weeklyTask/bg_reward_item_blue.svg')">
        <img v-if="prop_type === 4"
            :src="require('@/assets/images/YuliApp/weeklyTask/bg_reward_item_purple.svg')">
        <img v-if="prop_type === 5"
            :src="require('@/assets/images/YuliApp/weeklyTask/bg_reward_item_orange.svg')"/>
      </div>
      <!-- 道具图片 -->
      <div class="prop-box-img">
        <img :src="prop_img">
      </div>
      <!-- 数量 -->
      <div class="prop-box-number">
        <span
          :style="{
            color: prop_number_cur < prop_number_need ? '#FF9D9D' : '#BDFF00'
          }"
        >{{ prop_number_cur }}</span> / {{ prop_number_need }}
      </div>
    </div>
  </template>
<script>
import { onBeforeMount, onMounted, ref, computed, nextTick } from "vue";
import _ from "lodash";
import audioManager from "@/utils/audioManager";
import { anyTypeAnnotation } from "@babel/types";
  
  export default {
    components: {},
    props: {
      cur_kep: {
        type: Number,
        default: 0,
      },
      total_kep: {
        type: Number,
        default: 0,
      },
      propStyle: {
        type: Object,
        default: ()=>{
          return {}
        },
      },
      prop_type: {
        type: Number,
        default: 0
      },
      prop_img: {
        type: String,
        default: ''
      },
      prop_number_cur: {
        type: Number,
        default: 0,
      },
      prop_number_need: {
        type: Number,
        default: 1,
      }
    },

    setup(props, { emit }) {
      const { cur_kep, total_kep } = props;
      

  
      return {
        
      };
    },
  };
  </script>
  
  <style lang="less" scoped>
    .prop-box{
        width: 64px;
        height: 64px;
        position: relative;
        // margin-bottom: 9.5px;
        &-bg{
            position: absolute;
            width: 64px;
            height: 64px;
            z-index: 1;
            img{
                width: 100%;
                height: 100%;
            }
        }
        &-img{
            width: 56px;
            height: 56px;
            z-index: 2;
            position: absolute;
            top: 4px;
            left: 4px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        &-number{
            width: 100%;
            height: 15px;
            background: rgba(0, 0, 0, 0.4);
            z-index: 2;
            position: absolute;
            bottom: 0;
            border-radius: 0 0 4px 4px;
            text-align: center;
            line-height: 15px;
            color: rgba(255, 255, 255, 1);
            font-size: 12px;
            font-family: "PingFang SC";
        }
    }
  </style>
  